/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareClassEnum } from './share-class-enum';
import { InvestmentExportStatusEnum } from './investment-export-status-enum';

export interface DeckInvestmentsExportSimple {
  readonly id: string;
  readonly status: InvestmentExportStatusEnum;
  readonly allocation_date: string;
  readonly share_class: ShareClassEnum;
  readonly share_price: string;
}
export namespace DeckInvestmentsExportSimple {}
